import { useEffect } from 'react'
import { useLocation, useSearchParams } from 'react-router'

/**
 * Consume ?m=&seq= once the conversation has it, so a reload does not jump again. The entry keeps its state: a
 * conversation opened from a search result still goes back to the search (shell/useBack).
 */
export function useConsumeJump() {
  const [searchParams, setSearchParams] = useSearchParams()
  const { state } = useLocation()
  useEffect(() => {
    if (!searchParams.has('m')) return
    const next = new URLSearchParams(searchParams)
    next.delete('m')
    next.delete('seq')
    setSearchParams(next, { replace: true, state })
  }, [searchParams, setSearchParams, state])
}
